import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';

interface AlertModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    type?: 'error' | 'success' | 'info';
}

export const AlertModal: React.FC<AlertModalProps> = ({
    isOpen,
    onClose,
    title,
    message,
    type = 'info'
}) => {
    const { t } = useTranslation();

    const getIcon = () => {
        switch (type) {
            case 'error': return '❌';
            case 'success': return '✅';
            default: return '⚠️';
        }
    };

    const getBgColor = () => {
        switch (type) {
            case 'error': return 'bg-red-50 text-red-500';
            case 'success': return 'bg-green-50 text-green-500';
            default: return 'bg-blue-50 text-blue-500';
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-6 text-center">
                <div className={`mx-auto w-16 h-16 rounded-full flex items-center justify-center ${getBgColor()}`}>
                    <span className="text-3xl">{getIcon()}</span>
                </div>

                <p className="text-gray-600 font-medium whitespace-pre-wrap">{message}</p>

                <div className="pt-2">
                    <Button
                        onClick={onClose}
                        className="w-full py-3 rounded-xl font-bold bg-primary text-white shadow-lg shadow-primary/20 hover:bg-primary/90 transition-all"
                    >
                        {t('ok') || 'موافق'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
